import { Skeleton } from './Skeleton';
import { HeaderSkeleton } from './HeaderSkeleton';
import { CategoryTabsSkeleton } from './CategoryTabsSkeleton';
import { MenuListSkeleton } from './MenuItemSkeleton';

/**
 * Skeleton for the DoorDash-style RestaurantHero component.
 * Matches the full-bleed hero with logo + name at bottom-left.
 */
export function RestaurantHeroSkeleton() {
  return (
    <div className="relative h-64 bg-tg-secondary-bg overflow-hidden">
      {/* Cover image skeleton */}
      <Skeleton className="absolute inset-0 w-full h-full rounded-none" />
      {/* Dark gradient overlay to match real component */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
      {/* Logo + name at bottom-left */}
      <div className="absolute inset-x-0 bottom-0 flex items-end gap-3 px-4 pb-4">
        <Skeleton className="w-16 h-16 rounded-full flex-shrink-0 opacity-40" />
        <div className="flex-1 min-w-0 pb-0.5">
          <Skeleton className="h-6 w-40 rounded opacity-40" />
          <Skeleton className="mt-1 h-3 w-24 rounded opacity-30" />
        </div>
      </div>
    </div>
  );
}

/**
 * Full page skeleton for MenuPage
 * Shows DoorDash-style hero skeleton, sticky header/tabs, and menu items
 */
export function MenuPageSkeleton() {
  return (
    <div className="min-h-screen bg-tg-bg pb-24">
      {/* Hero skeleton */}
      <RestaurantHeroSkeleton />

      {/* Sticky container */}
      <div className="sticky top-0 z-20 bg-tg-bg">
        {/* Header skeleton */}
        <HeaderSkeleton />
        {/* Category tabs skeleton */}
        <CategoryTabsSkeleton />
      </div>

      {/* Menu list skeleton */}
      <MenuListSkeleton categoryCount={3} itemsPerCategory={3} />

      {/* Floating cart button skeleton */}
      <div className="fixed bottom-6 left-4 right-4">
        <div className="animate-pulse bg-tg-secondary-bg rounded-full h-14 shadow-lg" />
      </div>
    </div>
  );
}

